import { render } from "./SideBar.vue?vue&type=template&id=27828af4"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=27828af4&lang=scss"

import exportComponent from "C:\\Users\\The Knight\\Desktop\\Cashoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__